import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { SidePaneComponent } from '../../layout/sidepane/sidepane.component';
import { LayoutService } from '../../services/layout.service';

@Component({
    selector: 'app-fn-questionnaire',
    standalone: true,
    imports: [RouterOutlet, SidePaneComponent],
    styleUrl: "./public.component.scss",
    template: `
    <div class='main flex' [class.sidepane-visible]="isSidePaneVisible">
        <!-- <div class="sidebar-header">
            <div class="logo-container">
            <img src="/assets/images/logo_white.png" alt="GIP" class="logo" />
            </div>
        </div> -->
        <app-sidepane [defaultPosition]="'left'"></app-sidepane>
        <div class="flex-grow-1 align-items-center">
            <router-outlet></router-outlet>
        </div>
    </div>`
})
export class PublicComponent implements OnInit, OnDestroy {
    isSidePaneVisible = false;
    private destroy$ = new Subject<void>();

    constructor(private layoutService: LayoutService) {}

    ngOnInit(): void {
        // Subscribe to right panel visibility changes
        this.layoutService.isVisible$
            .pipe(takeUntil(this.destroy$))
            .subscribe(visible => {
                this.isSidePaneVisible = visible;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
